var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canUserSwitch)?_c('toggle-element',{attrs:{"disabled-icon":"edit","enabled-icon":"eye"},model:{value:(_vm.isInReadOnlyMode),callback:function ($$v) {_vm.isInReadOnlyMode=$$v},expression:"isInReadOnlyMode"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }